
export const ABC = (locale: string) => [
    "C",
    "",
    "D",
    "",
    "E",
    "F",
    "",
    "G",
    "",
    "A",
    "",
    locale === "hu" || locale === "et" || locale === "pl" || locale === "it" || locale === "es" || locale === "ca" || locale === "hr" || locale === "el" || locale === "lt" ? "H" : "B",
];

export const formatABC = (abc: string, octave: number) => {
    switch (octave) {
        case 0:
            return abc;
        case 1:
            return abc.toLowerCase();
        case 2:
            return abc.toLowerCase() + "’";
        case 3:
            return abc.toLowerCase() + "’’";
        case 4:
            return abc.toLowerCase() + "’’’";
        default:
            return abc;
    }
};
